<template>
  <Row>
    <Col span="24">
      <Card class="sum-card-box" :padding="0" style="border: 0px solid #efefef;background:#f1f1f1">
        <div class="header_box">
          <div class="header_br"></div>
          <div class="header_title">知识库</div>
        </div>
        <div class="work_title">产品知识体系</div>
        <div class="work_br"></div>
        <div class="middle_echarts">
          <div :style="{ width: '100%', height: height }" :id="uuid"></div>
        </div>
      </Card>
    </Col>
  </Row>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'knowledge',
  components: {},
  data() {
    return {
      id: null,
      chart: null,
      xAxisArr: [],
      data: null,
      columns1: [
        {
          title: '工单类型',
          key: 'type',
        },
        {
          title: '工单名称',
          key: 'title',
        },
        {
          title: '处理状态',
          key: 'status',
        },
        {
          title: '提交时间',
          key: 'time',
        },
        {
          title: '完成时间',
          key: 'time',
        },
        {
          title: '操作',
        },
      ],
      data1: [

      ],
    }
  },
  props: {
    title: {
      type: String,
      default: '近1个月知识库增量',
    },
    height: {
      type: String,
      default: '260px',
    },
  },
  computed: {
    uuid() {
      if (!this.id) {
        this.id = 'chart_data_id' + Math.ceil(Math.random() * 1000)
      }
      return this.id
    },
  },
  created() {
  },
  mounted() {
    this.initChart()
    //当前日期
  },
  methods: {
    initChart() {
      let q = {}
      this.chart && this.chart.showLoading()
      $utils.api
        .load('homeKnowledge', q, 'get')
        .then((res) => {
          if (res.code > 0) {
            // console.log(res.data)
            let arr = res.data || []
            let nameArr = []
            let numArr = []
            let rateArr = []
            arr.map((item) => {
              nameArr.push(item.name)
              numArr.push(item.num)
              rateArr.push(item.rate)
            })
            this.chart = echarts.init(document.getElementById(this.uuid), 'light')
            const option = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'none',
                  crossStyle: {
                    color: '#999',
                  },
                  //滑动x轴文字颜色
                  label: {
                    color: '#3B7FF6',
                    backgroundColor: '#fff',
                    shadowBlur: 0,
                    show: true,
                    fontSize: 14,
                  },
                  lineStyle: {
                    width: 30,
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: 'rgba(54, 123, 245, 0)', // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: 'rgba(54, 123, 245, 0.35)', // 100% 处的颜色
                        },
                      ],
                      global: false, // 缺省为 false,
                    },
                  },
                },
                backgroundColor: '#fff',
                borderRadius: 2,
                padding: [10, 10, 10, 10],
                textStyle: {
                  align: 'left',
                  fontSize: 14,
                },
                extraCssText: 'box-shadow: 0 4px 12px rgba(192, 195, 202, 0.4);', //额外附加到浮层的 css 样式
                formatter: function(v) {
                  var str = ''
                  v.forEach((item) => {
                    var unit = item.seriesName == '覆盖率' ? '%' : ''
                    var str2 =
                      '<div style="display: flex;justify-content:space-between;">' +
                      '<span style="color:#767FA6 ">' +
                      item.seriesName +
                      '：' +
                      '</span>' +
                      '<span style="color: ' +
                      item.color +
                      ';font-family:Microsoft YaHei;font-weight:600;">' +
                      item.data +
                      unit +
                      '</span>' +
                      '</div>'
                    str = str + str2
                  })
                  return str
                },
              },
              title: {},
              toolbox: {},
              legend: {
                top: '0%',
                left: 'center',
              },
              grid: {
                height: 'auto',
                left: '80px',
                right: '60px',
              },
              xAxis: [
                {
                  type: 'category',
                  data: nameArr,
                  axisPointer: {
                    type: 'line',
                  },
                  axisTick: {
                    //y轴刻度线
                    show: false,
                  },
                  axisLabel: {
                    show: true,
                    // interval: 0,
                    textStyle: {
                      color: '#767FA6',
                      fontSize: 14,
                    },
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#555',
                    },
                  },
                },
              ],
              yAxis: [
                {
                  type: 'value',
                  name: '(百分比)',
                  nameLocation: 'end',
                  min: 0,
                  max: 100,
                  interval: 20,
                  splitLine: {
                    show: true,
                    lineStyle: {
                      type: 'dashed',
                      width: 1,
                      color: '#fff',
                    },
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: '#767FA6',
                      fontSize: 14,
                    },
                  },
                  nameTextStyle: {
                    color: '#767FA6',
                    fontSize: 12,
                    padding: [0, 60, 0, 0],
                  },
                  axisTick: {
                    //y轴刻度线
                    show: false,
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#555',
                    },
                  },
                },
                {
                  type: 'value',
                  name: '',
                  axisLabel: {
                    interval: 0,
                    show: true,
                    textStyle: {
                      color: '#767FA6',
                      fontSize: 12,
                    },
                    formatter: function(name) {
                      if (name >= 10000 && name < 100000000) {
                        name = (name / 10000).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '万'
                      } else if (name >= 100000000) {
                        name = (name / 100000000).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '亿'
                      } else if (name >= 0 && name < 10) {
                        name = name 
                      }
                      return name
                    },
                  },
                  axisTick: {
                    //y轴刻度线
                    show: false,
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      type: 'dashed',
                      width: 1,
                      color: '#555',
                    },
                  },
                  nameTextStyle: {
                    color: '#767FA6',
                    fontSize: 12,
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#555',
                    },
                  },
                },
              ],
              series: [
                {
                  name: '增长率',
                  type: 'line',
                  barWidth: 30,
                  yAxisIndex: 0,
                  data: rateArr,
                  color: '#3B7FF6',
                  smooth: 0.5,
                },
                {
                  name: '知识库数量',
                  type: 'bar',
                  barWidth: 30,
                  data: numArr,
                  yAxisIndex: 1,
                  color: '#2BA245',
                  itemStyle: {
                    normal: {
                      label: {
                        show: false,
                        position: 'top',
                        textStyle: {
                          color: '#767FA6',
                          fontSize: 14,
                        },
                      },
                    },
                  },
                },
              ],
            }
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
              this.chart.resize()
            })
            // 折现设置点击事件，点击查询当天日期的每小时数据
          }
          this.chart && this.chart.hideLoading()
        })
        .catch((e) => {
          // console.log(e)
          // $utils.toast.error('数据异常' + e.message)
          this.chart && this.chart.hideLoading()
        })
    },
  },
}
</script>
<style lang="less" scoped>
.sum-card-box {
  float: left;
  width: 100%;
  height: 375px;
  margin-top: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  transition: 0.2s all ease;
  position: relative;
  padding: 20px 24px 8px;
  .header_box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .header_br {
    width: 4px;
    height: 20px;
    background-color: rgb(228, 4, 19);
  }
  .header_title {
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 15px;
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0px;
    text-decoration: none;
    margin-left: 10px;
  }
  .work_title {
    width: 105px;
    height: 35px;
    border-bottom: 3px solid rgba(228, 4, 19, 1);
    line-height: 35px;
    text-align: center;
    color: rgba(228, 4, 19, 1);
    font-size: 14px;
  }
  .work_br {
    width: 100%;
    height: 1px;
    background: #fff;
    margin-bottom: 20px;
  }
  .knowledge_box {
    display: flex;
    align-items: flex-end;
    margin-top: 40px;
    justify-content: space-between;
    width: 90%;
    .left {
      width: 350px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        display: flex;
        align-items: center;
        width: 160px;
        margin-bottom: 40px;
        .radio {
          width: 10px;
          height: 10px;
          border-radius: 10px;
          background: rgb(255, 24, 24);
          margin-right: 5px;
        }
        .text {
          font-family: SourceHanSansSC;
          font-weight: 400;
          font-size: 14px;
          color: rgb(16, 16, 16);
          font-style: normal;
        }
      }
    }
    .middle {
      .title {
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 16px;
        color: rgb(16, 16, 16);
        font-style: normal;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        min-width: 150px;
        .title {
          font-family: SourceHanSansSC;
          font-weight: 400;
          font-size: 14px;
          color: rgb(132, 132, 132);
          font-style: normal;
          margin-right: 20px;
        }
        .num {
          font-family: SourceHanSansSC;
          font-weight: 700;
          font-size: 14px;
          color: rgb(16, 16, 16);
          font-style: normal;
        }
      }
    }
  }
  .box {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .item {
      display: flex;
      align-items: center;
      justify-items: center;
      flex-direction: column;
      margin-left: 15px;
      margin-right: 35px;
      .image {
        width: 50px;
        height: 60px;
        background: #ccc;
      }
      .title {
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 14px;
        color: rgb(16, 16, 16);
        font-style: normal;
        margin-top: 10px;
      }
    }
  }
  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }
  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
